import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pages: [
      {
        id: 0,
        solutions: [
          {
            id: 0,
            formula: 'Mg(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              magnesium: {
                endMetalImg: false,
                endBeakerImg: false
              },
              copper: {
                endMetalImg: false,
                endBeakerImg: false
              },
              zinc:{
                endMetalImg: false,
                endBeakerImg: false
              },
              silver: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
          {
            id: 1,
            formula: 'Zn(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              magnesium: {
                endMetalImg: 'gray-dark-01-mini.png',
                endBeakerImg: false
              },
              copper: {
                endMetalImg: false,
                endBeakerImg: false
              },
              zinc:{
                endMetalImg: false,
                endBeakerImg: false
              },
              silver: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
          {
            id: 2,
            formula: 'Cu(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-blue-dark.png',
            reactions: {
              magnesium: {
                endMetalImg: 'copper-mini.png',
                endBeakerImg: 'beaker-blue-light.png'
              },
              copper: {
                endMetalImg: false,
                endBeakerImg: false
              },
              zinc:{
                endMetalImg: 'copper-mini.png',
                endBeakerImg: 'beaker-blue-light.png'
              },
              silver: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
          {
            id: 3,
            formula: 'AgNO<sub>3</sub>(aq)',
            charge: 1,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              magnesium: {
                endMetalImg: 'gray-02-mini.png',
                endBeakerImg: false
              },
              copper: {
                endMetalImg: 'silver-mini.png',
                endBeakerImg: 'beaker-teal.png'
              },
              zinc:{
                endMetalImg: 'silver-mini.png',
                endBeakerImg: false
              },
              silver: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
        ],
        metals: ['magnesium','copper','zinc','silver']
      },
      {
        id: 1,
        solutions: [
          {
            id: 4,
            formula: 'Fe(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-green.png',
            reactions: {
              tin: {
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              },
              nickel:{
                endMetalImg: false,
                endBeakerImg: false
              },
              iron: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
          {
            id: 5,
            formula: 'Pb(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              tin: {
                endMetalImg: 'gray-dark-01-mini.png',
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              },
              nickel:{
                endMetalImg: 'gray-dark-01-mini.png',
                endBeakerImg: 'beaker-teal.png'
              },
              iron: {
                endMetalImg: 'gray-dark-01-mini.png',
                endBeakerImg: 'beaker-green.png'
              }
            },
          },
          {
            id: 6,
            formula: 'Ni(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-teal.png',
            reactions: {
              tin: {
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              },
              nickel:{
                endMetalImg: false,
                endBeakerImg: false
              },
              iron: {
                endMetalImg: 'gray-02-mini.png',
                endBeakerImg: 'beaker-teal-greener.png'
              }
            },
          },
          {
            id: 7,
            formula: 'Sn(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              tin: {
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              },
              nickel:{
                endMetalImg: 'gray-01-mini.png',
                endBeakerImg: 'beaker-teal.png'
              },
              iron: {
                endMetalImg: 'gray-01-mini.png',
                endBeakerImg: 'beaker-green.png'
              }
            },
          },
        ],
        metals: ['tin','lead','nickel','iron']
      },
      {
        id: 2,
        solutions: [
          {
            id: 8,
            formula: 'Zn(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              iron: {
                endMetalImg: false,
                endBeakerImg: false
              },
              zinc: {
                endMetalImg: false,
                endBeakerImg: false
              },
              copper:{
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
          {
            id: 9,
            formula: 'Cu(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-blue-dark.png',
            reactions: {
              iron: {
                endMetalImg: 'copper-mini.png',
                endBeakerImg: 'beaker-teal.png'
              },
              zinc: {
                endMetalImg: 'copper-mini.png',
                endBeakerImg: 'beaker-blue.png'
              },
              copper:{
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: 'copper-mini.png',
                endBeakerImg: 'beaker-blue.png'
              }
            },
          },
          {
            id: 10,
            formula: 'Fe(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-green-dark.png',
            reactions: {
              iron: {
                endMetalImg: false,
                endBeakerImg: false
              },
              zinc: {
                endMetalImg: 'gray-01-mini.png',
                endBeakerImg: 'beaker-green.png'
              },
              copper:{
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
          {
            id: 11,
            formula: 'Pb(NO<sub>3</sub>)<sub>2</sub>(aq)',
            charge: 2,
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              iron: {
                endMetalImg: 'gray-dark-01-mini.png',
                endBeakerImg: 'beaker-green-dark.png'
              },
              zinc: {
                endMetalImg: 'gray-dark-02-mini.png',
                endBeakerImg: false
              },
              copper:{
                endMetalImg: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: false,
                endBeakerImg: false
              }
            },
          },
        ],
        metals: ['iron','zinc','copper','lead']
      },
      {
        id: 3,
        solutions: [
          {
            id: 12,
            formula: 'HCl (aq)',
            startBeakerImg: 'beaker-clear.png',
            reactions: {
              iron: {
                endMetalImg: 'iron-degraded.png',
                bubbles: 4,
                endBeakerImg: 'beaker-green.png'
              },
              tin: {
                endMetalImg: 'tin-degraded.png',
                bubbles: 2,
                endBeakerImg: false
              },
              copper:{
                endMetalImg: false,
                bubbles: false,
                endBeakerImg: false
              },
              lead: {
                endMetalImg: 'lead-degraded.png',
                bubbles: 1,
                endBeakerImg: false
              },
              zinc: {
                endMetalImg: 'zinc-degraded.png',
                bubbles: 5,
                endBeakerImg: false
              },
              nickel: {
                endMetalImg: 'nickel-degraded.png',
                bubbles: 3,
                endBeakerImg: 'beaker-teal.png'
              },
            },
          },
        ],
        metals:['copper', 'tin', 'lead', 'zinc', 'nickel', 'iron']
      }
    ]
  },
  getters:{
    getPage: state => id => {
      const page = state.pages[id]
      return page
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
